import Vue from 'vue'
import Vuex from 'vuex'
import adsStore from './ads'
import airportsStore from './airports'
import driverReviewStore from './driver-review'
import instructionsStore from './instructions'
import loginSignupStore from './login-signup'
import reservationStore from './reservation/index'
import rsvpEditStore from './rsvp-edit'
import rsvpTrackStore from './rsvp-track'
import serviceSelectionStore from './service-selection/index'
import staticLocationsStore from './static-locations'
import trackingStore from './tracking/index'
import userStore from './user/index'
import MoreImages from './more-images/index'
import experiment from './experiment'
import discountCode from './discount-code'
import thankyou from './thankyou'
import rerender from './rerender'
import other from './other'
import global from './global'
import cards from './cards'
import flights from './flights'
import gtag from './gtag'
import things from './things-to-do'
import sightSeeing from './sight-seeing'
import hotel from './hotel'
import lyft from './lyft'

import booking from './booking'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    ads: adsStore,
    airports: airportsStore,
    driverReview: driverReviewStore,
    instructions: instructionsStore,
    loginSignup: loginSignupStore,
    reservation: reservationStore,
    rsvpEdit: rsvpEditStore,
    rsvpTrack: rsvpTrackStore,
    serviceSelection: serviceSelectionStore,
    staticLocations: staticLocationsStore,
    tracking: trackingStore,
    user: userStore,
    moreImages: MoreImages,
    experiment: experiment,
    discountCode: discountCode,
    thankyou: thankyou,
    rerender: rerender,
    other: other,
    global: global,
    cards: cards,
    flights: flights,
    gtag: gtag,
    booking: booking,
    things: things,
    sightSeeing: sightSeeing,
    hotel: hotel,
    lyft: lyft
  },
  state: {
    brandId: null,
    brandCode: null,
    currentIndex: 0,
    progressSteps: [
      {
        label: 'Choose your Ride',
        link: 'service',
        disabled: false
      },
      {
        label: 'Enter your Details',
        link: 'customer',
        disabled: true
      },
      {
        label: 'Payment Details',
        link: 'payment',
        disabled: true
      },
      {
        label: 'Review and Book',
        link: 'review',
        disabled: true
      }
    ],
    selectedCard: {
      id: -1
    },
    tip: {
      label: 'Add Tip',
      amount: 0,
      leg1: 0,
      leg2: 0,
      intl: 0
    },
    isManualTip: false,
    fare: 0,
    bidRequest: null,
    credits: 0,
    showPaymentBreakdown: false,
    showPromoCodeInput: false,
    searchMapModal: {
      show: false,
      target: '',
      location: null
    },
    guestInfo: {
      proxy: false,
      firstName: '',
      lastName: '',
      mobile: '',
      countryCode: ''
    },
    wheelChair: false,
    serviceDog: false,
    driverNotes: {
      leg1: '',
      leg2: ''
    },
    searchPickup: '',
    searchDropoff: '',
    travelInsuranceLabel: 'Travel Insurance',
    hasPassCustomerPage: false
  },
  mutations: {
    setBrand (state, brandId) { state.brandId = brandId },
    setBrandCode (state, value) { state.brandCode = value },
    setCurrentIndex (state, index) { state.currentIndex = index },
    enablePreviousSteps (state, index) {
      for (let i = index; i > 0; i--) {
        state.progressSteps[i].disabled = false
      }
    },
    disablePreviousSteps (state, index) {
      for (let i = index; i > 0; i--) {
        state.progressSteps[i].disabled = true
      }
    },
    setSelectedCard (state, card) { state.selectedCard = card },
    setTipAmount (state, tip) { state.tip.amount = tip },
    setTipLabel (state, label) { state.tip.label = label },
    setTipLeg (state, data) { state.tip[data.leg] = data.value },
    setIsManualTip (state, value) { state.isManualTip = value },
    setTipIntl (state, val) { state.tip.intl = val },
    setBackLink (state, link) {
      state.progressSteps[0].link = link
    },
    setFare (state, fare) {
      state.fare = fare
    },
    setBidRequest (state, bidRequest) {
      state.bidRequest = bidRequest
    },
    setCredits (state, value) {
      state.credits = value
    },
    setShowPaymentBreakdown (state, value) {
      state.showPaymentBreakdown = value
    },
    setShowPromoCodeInput (state, value) {
      state.showPromoCodeInput = value
    },
    setEnableGuestInfo (state, value) {
      state.guestInfo.proxy = value
    },
    updateGuest (state, value) {
      state.guestInfo.proxy = value.proxy
      state.guestInfo.firstName = value.firstName
      state.guestInfo.lastName = value.lastName
      state.guestInfo.mobile = value.mobile
      state.guestInfo.countryCode = value.countryCode
    },
    setDriverNotes (state, value) {
      if (value.leg === 'leg1') {
        state.driverNotes.leg1 = value.notes
      } else {
        state.driverNotes.leg2 = value.notes
      }
    },
    setWheelChair (state, value) {
      state.wheelChair = value
    },
    setServiceDog (state, value) {
      state.serviceDog = value
    },
    setPickup (state, value) {
      state.searchPickup = value
    },
    setDropoff (state, value) {
      state.searchDropoff = value
    },
    setTravelInsuranceLabel (state, value) { state.TravelInsuranceLabel = value },
    setHasPassCustomerPage (state, value) { state.hasPassCustomerPage = value },
    setProgressLabel (state, data) {
      state.progressSteps[0].label = data[0]
      state.progressSteps[1].label = data[1]
      state.progressSteps[2].label = data[2]
      state.progressSteps[3].label = data[3]
    },
    setShowMapModal (state, value) {
      state.searchMapModal.show = value.show
      state.searchMapModal.target = value.target
    },
    setMapLocation (state, value) {
      state.searchMapModal.location = value
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js